import $ from 'jquery';
import prestashop from 'prestashop';

const $window = $(window);

const selector = 'header#header';

$(() => {

    const $stickyHeader = $(selector);

    if (0 == $stickyHeader.length) return;

    injectStickyHeaderStyles();

    $window.on('scroll', function () {

        if (prestashop.responsive.mobile) return;


        if ($window.scrollTop() >= $stickyHeader.outerHeight()) {
            $stickyHeader.addClass('fixed-header');
        } else {
            $stickyHeader.removeClass('fixed-header');
        }
    });


    function injectStickyHeaderStyles() {
        const headerHeight = $stickyHeader.outerHeight() || 195; // Valeur par défaut si non trouvée

        const styleContent = `
            @keyframes slidemenu {
                0% {
                    top: -${headerHeight}px;
                }
                to {
                    top: 0;
                }
            }

            #header.fixed-header {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                animation: slidemenu 1s;
            }

            *:has(>#header.fixed-header) {
                padding-top: ${headerHeight}px;
            }
        `;

        $('<style>', { text: styleContent }).appendTo('head');
    }
});
